import RewardsResults, { RESULTS_TYPE } from './RewardsResults';

export default RewardsResults;
export { RESULTS_TYPE };
